export const environment = {
  production: true,
  clientRoot:`${window.location.origin}`,
  apiRoot: 'https://v2identity.raksainfo.info/api/',
    //  apiRoot: 'https://v2identity.raksainfo.info/api/',
  // apiRoot: 'https://localhost:44347/api/',
  stsAuthority: 'https://identity.raksainfo.info',
  // OpenIddict AuthServer that hosts the self-service account pages (/account/manage/*,
  // /account/confirmprofile).
  authServerRoot: 'https://identity.raksainfo.info',
  clientId:"raksaInfo-v4-client",
  analyticsEnabled: true,
  pushNotificationsEnabled: false,
  vapidPublicKey: '',
  googleApiKey: 'AIzaSyAPQnAVT-GKhkEDvZD5V2D-hXL9kjlG4jI',
  googleCseId: '45c798e97e6cc24f5',
  // Build metadata (optional). Populate via CI for better error diagnostics.
  appVersion: '4.2026.45+254.63da8645',
  buildSha: '63da86452398ccf31550899641c5cfb10c85d64e',
  buildTime: '2026-11-05T08:57:30.870Z',
  // Optional human name of the current major release (from release.json via set-build-info.mjs).
  // Empty = no codename is shown anywhere.
  codename: 'Cornerstone'
};
